<template>
  <a :href="link">
    <slot/>
  </a>
</template>
<script>
export default {
  props: {
    to: {
      required: true
    }
  },

  computed: {
    link () {
      return this.$serverRoute(this.to)
    }
  }
}
</script>
